import { IEngagementComment } from 'pages/WirelineEngagements/WirelineEngagements.models';
import {
  GET_ENGAGEMENTS_COMMENTS_REQUEST,
  GET_ENGAGEMENTS_COMMENTS_SUCCESS,
  GET_ENGAGEMENTS_COMMENTS_FAILURE,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/GetComments/actionTypes';
import {
  CREATE_ENGAGEMENTS_COMMENT_REQUEST,
  CREATE_ENGAGEMENTS_COMMENT_SUCCESS,
  CREATE_ENGAGEMENTS_COMMENT_FAILURE,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/CreateComment/actionTypes';
import {
  EDIT_ENGAGEMENTS_COMMENT_REQUEST,
  EDIT_ENGAGEMENTS_COMMENT_SUCCESS,
  EDIT_ENGAGEMENTS_COMMENT_FAILURE,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/EditComment/actionTypes';
import {
  REMOVE_ENGAGEMENTS_COMMENT_REQUEST,
  REMOVE_ENGAGEMENTS_COMMENT_SUCCESS,
  REMOVE_ENGAGEMENTS_COMMENT_FAILURE,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/RemoveComment/actionTypes';
import {
  CLEAR_ERRORS_ENGAGEMENTS_COMMENT,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/ClearErrorsComments/actionTypes';

interface IEngagementCommentsState {
  error: string
  isLoading: boolean
  data: {
    results: IEngagementComment[]
  }
}

const initialState: IEngagementCommentsState = {
  error: '',
  isLoading: false,
  data: {
    results: [],
  },
};

const commentsReducer = (state = initialState, {
  type, comments, newComment, commentId, editedComment, error,
}) => {
  switch (type) {
    case GET_ENGAGEMENTS_COMMENTS_REQUEST:
    case CREATE_ENGAGEMENTS_COMMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ENGAGEMENTS_COMMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          results: comments,
        },
        error: '',
      };
    case CREATE_ENGAGEMENTS_COMMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          results: [
            ...state.data.results.map((comment) => (
              {
                ...comment,
                error: '',
              }
            )),
            newComment,
          ],
        },
        error: '',
      };
    case GET_ENGAGEMENTS_COMMENTS_FAILURE:
    case CREATE_ENGAGEMENTS_COMMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error,
      };
    case EDIT_ENGAGEMENTS_COMMENT_REQUEST:
    case REMOVE_ENGAGEMENTS_COMMENT_REQUEST:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((comment) => ((comment.id === commentId) ? {
            ...comment,
            isLoading: true,
          } : comment)),
        },
      };
    case EDIT_ENGAGEMENTS_COMMENT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((comment) => ((comment.id === editedComment.id) ? {
            ...comment,
            ...editedComment,
            isLoading: false,
            error: '',
          } : comment)),
        },
      };
    case REMOVE_ENGAGEMENTS_COMMENT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.filter(
            (comment) => comment.id !== commentId,
          ),
        },
      };
    case EDIT_ENGAGEMENTS_COMMENT_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((comment) => ((comment.id === commentId) ? {
            ...comment,
            isLoading: false,
            error,
          } : comment)),
        },
      };
    case REMOVE_ENGAGEMENTS_COMMENT_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((comment) => ((comment.id === commentId) ? {
            ...comment,
            isLoading: false,
            error,
          } : comment)),
        },
      };
    case CLEAR_ERRORS_ENGAGEMENTS_COMMENT:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((comment) => ({
            ...comment,
            error: '',
          })),
        },
        error: '',
      };
    default:
      return state;
  }
};

export default commentsReducer;
